import { IconButton, Typography } from "@mui/material";
import { FaTrash } from "react-icons/fa6";

import { TLocalLessonDocument } from "../../hooks/useMyCourseInstructor";

export type TCloudLessonDocumentProps = {
	lessonDocument: TLocalLessonDocument;
	onClickRemoveFile: (id: string) => void;
};

export function LocalLessonDocument({
	lessonDocument,
	onClickRemoveFile,
}: TCloudLessonDocumentProps) {
	return (
		<div className="lesson-media-item">
			<Typography flex={1} className="normal-text">
				{lessonDocument.file.name}
			</Typography>
			<IconButton
				className="icon-button"
				onClick={() => {
					onClickRemoveFile(lessonDocument.id);
				}}>
				<FaTrash />
			</IconButton>
		</div>
	);
}
